import { WishListIconComponent } from '@msdyn365-commerce/components';
import * as MsDyn365 from '@msdyn365-commerce/core';
import { Button, ITelemetryContent, UncontrolledTooltip } from '@msdyn365-commerce-modules/utilities';
import classnames from 'classnames';
import * as React from 'react';

import { SignInComponent } from '../../gh-signin-button/components/SignInComponent';

export interface IHeaderWishlistIconProps {
    className: string;
    tooltipText: string;
    showTooltip: boolean;
    wishlistCount: number;
    wishlistCountLabel: string;
    showWishlistCount?: boolean;
    signInDrawerTitle: string;
    moduleProps: MsDyn365.IModule;
    context: MsDyn365.ICoreContext;
    id: string;
    typeName: string;
    telemetryContent?: ITelemetryContent;
}

/**
 * Wishlist trigger shown to anonymous users.
 * opens the sign-in drawer instead of navigating to the B2C policy.
 */
const AnonymousWishlistIcon: React.FC<IHeaderWishlistIconProps> = props => {
    const { className, tooltipText, showTooltip, signInDrawerTitle, moduleProps } = props;
    const triggerRef = React.useRef<HTMLButtonElement>(null);

    return (
        <SignInComponent
            drawerTitle={signInDrawerTitle}
            moduleProps={moduleProps}
            renderTrigger={open => (
                <>
                    <Button
                        className={classnames('msc-wishlist-icon', className)}
                        aria-label={tooltipText}
                        innerRef={triggerRef}
                        onClick={open}
                    >
                        <span className='msc-wishlist-icon__text'>{tooltipText}</span>
                    </Button>
                    {showTooltip && (
                        <UncontrolledTooltip trigger='hover focus' target={triggerRef}>
                            {tooltipText}
                        </UncontrolledTooltip>
                    )}
                </>
            )}
        />
    );
};

/**
 * Header wishlist icon. Signed-in users get the SDK component with its
 * server-backed count; guests get a trigger that opens the sign-in drawer.
 */
export const HeaderWishlistIcon: React.FC<IHeaderWishlistIconProps> = props => {
    if (!props.context.request.user.isAuthenticated) {
        return <AnonymousWishlistIcon {...props} />;
    }

    return (
        <WishListIconComponent
            className={props.className}
            showButtonTooltip={props.showTooltip}
            wishlistTooltipText={props.tooltipText}
            context={props.context}
            id={props.id}
            typeName={props.typeName}
            telemetryContent={props.telemetryContent}
            data={{}}
            wishlistCount={props.wishlistCount}
            wishlistCountLabel={props.wishlistCountLabel}
            isDispayWishlistCount={props.showWishlistCount}
        />
    );
};
